export const GET_APPOINTMENTS_LIST = 'APT/get_appointments_list';
export const CREATE_APPOINTMENTS = 'APT/create_appointments';
export const UPDATE_APPOINTMENTS = 'APT/update_appointments';
export const SHOW_APPOINTMENTS = 'APT/show_appointments';
export const DELETE_APPOINTMENTS = 'APT/delete_appointments';

export const GET_ROLE_LIST = 'APT/get_role_list';

export const GET_SYSTEM_MODULES = 'SYSTEM_MODULES/get_system_modules';